"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnswerTypes = exports.ObjectTypes = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var ObjectTypes = (0, _keyMirror.default)({
  CONTACT: null,
  COMPANY: null,
  DEAL: null,
  TICKET: null
});
exports.ObjectTypes = ObjectTypes;
var AnswerTypes = (0, _keyMirror.default)({
  TEXT_ONLY: null,
  QUICK_REPLIES: null,
  PROPERTY_QUICK_REPLIES: null
});
exports.AnswerTypes = AnswerTypes;